export const SAVE_RULE_REQUEST = 'receipt-rules/save-rule-request';
export const UPDATE_RULE_REQUEST = 'receipt-rules/update-rule-request';
export const GET_RULES_FOR_APPLICATION_CONNECTION_REQUEST = 'receipt-rules/get-rules-for-application-connection-request';
export const GET_RULE_FOR_APPLICATION_CONNECTION_REQUEST = 'receipt-rules/get-rule-for-application-connection-request';
export const ENABLE_DISABLE_RULE_REQUEST = 'receipt-rules/enable-disable-rule-request';
export const DELETE_RULE_REQUEST = 'receipt-rules/delete-rule-request';
export const SET_RULES_FOR_APPLICATION_CONNECTION = 'receipt-rules/set-rules-for-application-connection';
export const SET_RULE_STATE = 'receipt-rules/set-rules-state';
export const DELETE_RULE_FROM_STATE = 'receipt-rules/delete-rule-from-state';
export const UPDATE_ENABLED_DISABLED_STATE =
  'receipt-rules/update-enabled-disabled-state';
export const PARSE_RULE_REQUEST = 'receipt-rules/parse-rule-request';
export const PARSE_RULE_DONE = 'receipt-rules/parse-rule-done';